import {
  bookingDraftInvoiceAmount,
  hasBookingDraftInvoice,
} from "@/lib/bookingInvoiceStatus";
import type { Booking, BookingDeparture } from "@/types/camping";

export type BookingWithInvoiceFields = Booking | BookingDeparture;

export function hasOpenInvoiceAmount(booking: BookingWithInvoiceFields): boolean {
  if (!("open_invoice_amount" in booking)) return false;
  return Number(booking.open_invoice_amount) > 0;
}

export function hasMissingInvoice(booking: BookingWithInvoiceFields): boolean {
  if (!("invoice_count" in booking)) return false;
  return (
    booking.invoice_count === 0 &&
    !hasOpenInvoiceAmount(booking) &&
    !hasBookingDraftInvoice(booking)
  );
}

/** Offene oder fehlende Rechnung – gleiche visuelle Priorität in Listen. */
export function invoiceNeedsAttention(booking: BookingWithInvoiceFields): boolean {
  return hasOpenInvoiceAmount(booking) || hasMissingInvoice(booking);
}

export function invoiceAttentionSortKey(booking: BookingWithInvoiceFields): number {
  if (hasOpenInvoiceAmount(booking)) return 0;
  if (hasMissingInvoice(booking)) return 1;
  if (hasBookingDraftInvoice(booking)) return 2;
  return 3;
}

export function openInvoiceCount(booking: BookingWithInvoiceFields): number {
  if (!("open_invoice_count" in booking)) return 0;
  return booking.open_invoice_count;
}

export function draftInvoiceDisplayAmount(booking: BookingWithInvoiceFields): number {
  return bookingDraftInvoiceAmount(booking);
}
